import fecha from 'fecha';

export const textFormatter = ({ value }) => {
  return value;
};

export const currency = (value, plain) => {
  if(value == null ||  value === '' || typeof value === 'undefined' ) return '';
  const parsed = parseFloat(value);
  if (plain) {
      return parsed.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return currencyFormatter({value: parsed});
};

export const percentageFormatter = ({value}) =>{
  if(value === null || typeof value === 'undefined') value = 0;
  return  (value * 100).toFixed(5) + "%";
}

export const currencyFormatter = ({ value }) => {
  if(value === null || typeof value === 'undefined') value = 0;
  const result =  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);

  
  //console.log(`%c Currency Formatter ${value} to ${result} `, 'background: blue; color: white; display: block;');

  return result;
};
export const dateFormatter = ({ value }) => {
  var date = Date.parse(value);

  if (!date) return value;

  return fecha.format(date, fecha.masks.shortDate);
};


export const dateFormatterLong = ({ value }) => {
  var date = Date.parse(value);

  if (!date) return value;

  return fecha.format(date, 'M/D/YY h:mm A');
};
export const byteFormatter = ({ value }) => {
  return `${value} Bytes`;
};

export const phoneFormatter = value => {
  if(!value) return '';
  if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
    value = value.value;
  }
  let phone = value;
  let first = '';
  let second = '';
  let third = '';
  if (value !== null && value.length === 10) {
    first = value.substring(0, 3);
    second = value.substring(3, 6);
    third = value.substring(6, value.length);
    phone = `(${first}) ${second}-${third}`;
    // console.log(phone)
  }
  return phone;
};

export const zipCodeFormatter = value => {
  if (!value) return '';
  if (typeof value === 'object' && value.value) {
    value = value.value;
  }
  if (value.length === 5) {
    return value;
  } else if (value.length === 9) {
    return value.substring(0, 5) + '-' + value.substring(5);
  } else {
    return value;
  }
};
export const federalTaxIDFormatter = value => {
  if (!value) return '';
  if (typeof value === 'object' && value.value) {
    value = value.value;
  }
  if (value.length !== 9) return value;
  return value.substring(0, 2) + '-' + value.substring(2);
};

export const SSNFormatter = value => {
  if (!value) return '';
  if (typeof value === 'object' && value.value) {
    value = value.value;
  }
  if (value.length !== 9) return value;
  return (
    value.substring(0, 3) +
    '-' +
    value.substring(3, 5) +
    '-' +
    value.substring(5)
  );
};
export const phoneRemoveSpecialSymbols = value => {
  let phone = value.replace(/[^\w\s]/gi, '').replace(' ', '');
  return phone;
};
